import React from 'react';
import { Check, Shield, Zap, Users } from 'lucide-react';

export default function About() {
  return (
    <div className="pt-28">
      {/* Content Section */}
      <section className="py-24 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-20">
            <div className="space-y-12">
              {/* Page Title & Intro */}
              <div>
                <h1 className="text-4xl md:text-6xl font-bold text-black mb-8 tracking-tight uppercase">
                  L1 – kvalitet, sikkerhed og <span className="text-[#C1121F]">professionelt håndværk</span>
                </h1>
                <p className="text-xl text-gray-600 leading-relaxed">
                  L1 er en moderne el-virksomhed med fokus på kvalitet, pålidelighed og professionelle løsninger. Vi arbejder med både private, erhverv og entrepriser, hvor vores mål altid er at levere stabile installationer og høj service.
                </p>
              </div>

              <div className="text-black">
                <h2 className="text-xl font-bold text-black mb-6 uppercase tracking-wider">Vores vision</h2>
                <div className="mt-12 mb-16 prose prose-p:text-black prose-p:text-xl prose-p:leading-relaxed prose-p:mb-6 max-w-none">
                  <p>
                    Vi arbejder med både private, erhverv og entrepriser, hvor vores mål altid er at levere stabile installationer og høj service. Vi tror på, at godt håndværk og moderne teknologi går hånd i hånd.
                  </p>
                  <p>
                    Som autoriseret el-installatør sikrer vi, at alle opgaver løses efter gældende lovgivning og med øje for den mest optimale løsning for kunden. Vi bygger fremtidens el-løsninger med fokus på driftssikkerhed.
                  </p>
                </div>
              </div>

              <div>
                <h2 className="text-xl font-bold text-gray-900 mb-8 uppercase tracking-wider">Hvorfor vælge os?</h2>
                <div className="grid sm:grid-cols-2 gap-8">
                  <div className="space-y-4">
                    <Users className="w-6 h-6 text-black" />
                    <h4 className="text-lg font-bold text-black uppercase tracking-tight">God kommunikation</h4>
                    <p className="text-gray-600 text-sm font-medium">Vi holder hvad vi lover og sikrer en tæt dialog gennem hele forløbet.</p>
                  </div>
                  <div className="space-y-4">
                    <Shield className="w-6 h-6 text-black" />
                    <h4 className="text-lg font-bold text-black uppercase tracking-tight">Høj kvalitet</h4>
                    <p className="text-gray-600 text-sm font-medium">Vi går aldrig på kompromis med sikkerheden eller kvaliteten af vores arbejde.</p>
                  </div>
                  <div className="space-y-4">
                    <Zap className="w-6 h-6 text-black" />
                    <h4 className="text-lg font-bold text-black uppercase tracking-tight">Effektive løsninger</h4>
                    <p className="text-gray-600 text-sm font-medium">Vi optimerer dine installationer for bedre drift og lavere energiforbrug.</p>
                  </div>
                  <div className="space-y-4">
                    <Check className="w-6 h-6 text-black" />
                    <h4 className="text-lg font-bold text-black uppercase tracking-tight">Professionelt samarbejde</h4>
                    <p className="text-gray-600 text-sm font-medium">Vi er en pålidelig partner for både private og store entreprenører.</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="space-y-8">
              <div className="sticky top-40">
                <div className="relative aspect-[4/5] rounded-none overflow-hidden border border-gray-200 group">
                  <img
                    src="https://assets.auxodev.dk/assets/c790a797-f8bb-43f8-b6f5-1dd422b46a5f/9c348c98-7a96-46cd-8dee-80f18c09e318.jpg"
                    alt="L1 El-installatør"
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
                </div>
                
                <div className="mt-12 p-8 bg-[#C1121F] rounded-none">
                  <div className="text-4xl font-bold text-white mb-2 uppercase">Autoriseret</div>
                  <div className="text-white/80 text-sm font-semibold uppercase tracking-widest">El-installatør</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-24 bg-black">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-[#111] border border-white/5 p-12 md:p-20 rounded-none">
            <div className="max-w-3xl">
              <h2 className="text-2xl md:text-3xl font-bold text-white mb-8 uppercase tracking-tight">Vores kerneværdier</h2>
              <ul className="space-y-6">
                {[
                  'Autoriseret el-installatør med mange års erfaring.',
                  'Fokus på driftssikkerhed og fremtidssikrede løsninger.',
                  'Gennemsigtige priser og klare aftaler.',
                  'Vi rydder altid op efter os selv og overholder alle deadlines.'
                ].map((text, i) => (
                  <li key={i} className="flex items-start space-x-4">
                    <Check className="w-6 h-6 text-white shrink-0 mt-1" />
                    <span className="text-lg text-gray-300">{text}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
